import React, {useEffect, useState} from "react";
import style from './Navbar.module.css'
import {NavLink} from "react-router-dom";

export const Navbar = ({history}) => {

    const [activePath, setActivePath] = useState('/');

    const styleActiveRefProject = activePath === '/projects' ? style.activeProjects : style.projects;
    const styleActiveRefAbout = activePath === '/' ? style.activeAbout : style.about;

    useEffect(() => {
        if (history.location.pathname !== activePath) setActivePath(history.location.pathname);
    }, [])


    return (
            <div className={style.refs}>
                <div className={styleActiveRefAbout} onClick={() => setActivePath('/')}>
                    <NavLink to={'/'}>Обо мне</NavLink>
                </div>

                <div className={styleActiveRefProject} onClick={() => setActivePath('/projects')}>
                    <NavLink to={'/projects'}>Проекты</NavLink>
                </div>
        </div>
    )
}